<div class="loading" *ngIf="loading">
	<img src="assets/images/logo-zenoffice-default.svg" alt="ZenOffice" />
	<div class="row">
		<h2>Iniciando sessão...</h2>
		<freud-loader size="sm" [bgColor]="false"></freud-loader>
	</div>
</div>

<div
	#jitsiElement
	class="videoconference"
	[ngClass]="{ hidden: loading }"
></div>
